import type React from "react";
import { useLocation } from "react-router-dom";
import ClientLayout from "./client-layout";
import { PageTitleProvider } from "../contexts/page-title-context";
export default function ConditionalLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { pathname } = useLocation();
  const isPublicPage =
    pathname === "/" ||
    pathname === "/login" ||
    pathname === "/forgot-password" ||
    pathname === "/access-denied" ||
    pathname.startsWith("/auth");
  if (isPublicPage) {
    return <>{children}</>;
  }
  return (
    <PageTitleProvider>
      <ClientLayout>{children}</ClientLayout>
    </PageTitleProvider>
  );
}
